var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-section',{attrs:{"theme":"blue","title":"其他保單筆記","isLoading":_vm.isLoading,"datas":_vm.highlightModify,"_fields":[
      {
        name: '編號',
        key: 'ceplcno',
        width: 100,
        sortable: true,
        orderByMultiKey: ['ceplcno'],
        orderByMultiType: ['asc']
      },
      {
        name: '公司',
        key: 'comp_nm',
        width: 100,
        sortable: true,
        orderByMultiKey: ['comp_nm'],
        orderByMultiType: ['asc']
      },
      {
        name: '契約別',
        key: 'contract_type_nm',
        width: 80,
        sortable: true,
        orderByMultiKey: ['contract_type_nm'],
        orderByMultiType: ['asc']
      },
      {
        name: '被保人',
        key: 'ceisdnm',
        width: 80,
        sortable: true,
        className: 'link text-underline',
        orderByMultiKey: ['ceisdnm'],
        orderByMultiType: ['asc']
      },
    //   {
    //     name: '險種',
    //     key: 'contract_type',
    //     width: 80,
    //     sortable: true,
    //     orderByMultiKey: ['contract_type'],
    //     orderByMultiType: ['asc']
    //   },
      {
        name: '投保日期',
        key: 'ceplcdt',
        width: 80,
        sortable: true,
        className: 'text-left',
        orderByMultiKey: ['ceplcdt'],
        orderByMultiType: ['asc']
      },
      {
        name: '投保年期',
        key: 'prd',
        width: 80,
        sortable: true,
        className: 'text-left',
        orderByMultiKey: ['prd'],
        orderByMultiType: ['asc']
      },
      {
        name: '保額',
        key: 'famt',
        width: 80,
        thClassName: 'text-right',
        className: 'text-right',
        sortable: true,
        orderByMultiKey: ['famt'],
        orderByMultiType: ['asc']
      },
      {
        name: '保費',
        key: 'premium',
        width: 80,
        thClassName: 'text-right',
        className: 'text-right',
        sortable: true,
        orderByMultiKey: ['premium'],
        orderByMultiType: ['asc']
      },
      {
        name: '備註',
        key: 'remark',
        width: 120,
        thClassName: 'text-left',
        className: 'text-left',
        sortable: true,
        orderByMultiKey: ['remark'],
        orderByMultiType: ['asc']
      }
    ].concat(_vm._fields),"initShow":_vm.$route.query['OtherPropertyInsuranceNoteShow'] !== 'false'},on:{"toggle":function (isShow) { return _vm.$router.assignQuery({ OtherPropertyInsuranceNoteShow: isShow }); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm.refresh?[_c('data-table',_vm._b({staticClass:"mt-3",attrs:{"initSort":_vm.$route.query["OtherPropertyInsuranceNoteSort"]
          ? JSON.parse(_vm.$route.query["OtherPropertyInsuranceNoteSort"])
          : null},on:{"changeSort":function (sort) {
              var _obj;

              return _vm.$router.assignQuery(( _obj = {}, _obj["OtherPropertyInsuranceNoteSort"] = JSON.stringify(sort), _obj ));
    }},scopedSlots:_vm._u([{key:"contract_type",fn:function(item){return [_vm._v(_vm._s(_vm.translate.newContractType[item.data.contract_type]))]}},{key:"ceisdnm",fn:function(item){return [_c('span',{on:{"click":function($event){_vm.routeToCustDetail(item.data.ceisdno , item.data.ceisdnm)}}},[_vm._v("\n          "+_vm._s(_vm._f("truncate")(item.data.ceisdnm))+"\n        ")])]}},{key:"ceplcdt",fn:function(item){return [_vm._v("\n        "+_vm._s(_vm._f("dateFormatStart")(item.data.ceplcdt))+"\n        ")]}},{key:"famt",fn:function(item){return [_vm._v(_vm._s(_vm._f("numberFormat")(Number(item.data.famt)))+"元")]}},{key:"premium",fn:function(item){return [_vm._v(_vm._s(_vm._f("numberFormat")(Number(item.data.premium)))+"元")]}},{key:"remark",fn:function(item){return [_c('div',{domProps:{"innerHTML":_vm._s(item.data.remark)}})]}},{key:"action",fn:function(item){return [_c('div',{staticClass:"dropdown"},[_c('a',{staticClass:"btn btn-icon btn-default btn-sm",attrs:{"data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false","role":"button"}},[_c('i',{staticClass:"icon-more"})]),_c('div',{staticClass:"dropdown-menu"},[_c('a',{staticClass:"dropdown-item text-green text-underline",attrs:{"role":"button"},on:{"click":function($event){_vm.toUpdate(item.data.pt_contractx_id)}}},[_vm._v("修改")]),_c('a',{staticClass:"dropdown-item text-green text-underline",attrs:{"role":"button"},on:{"click":function($event){_vm.doDelete(item.data)}}},[_vm._v("刪除")])])])]}}])},'data-table',props,false))]:undefined}}])})}
var staticRenderFns = []

export { render, staticRenderFns }